/**
 * ReviewView.jsx - Review roster before locking
 * Phase 3B Round 2 - Named export only
 * Beta v2 - Lock button removed (admin controls lock)
 * 
 * Extracted from GMRosterBuilderV2.jsx lines 375-430
 * FIXED: bottom-16 to sit above BottomNav
 */

import React from 'react';
import { ChevronLeft } from 'lucide-react';
import { UnitWheel } from '../../../components/viz';
import PositionStrip from '../../../components/builder/PositionStrip';
import OverUnderStrip from '../../../components/builder/OverUnderStrip';
import { POSITION_COLORS } from '../../../components/builder/RosterSlot';
import { WeekLockBanner } from '../../../components/common/WeekLockBanner';

export const ReviewView = ({
  roster,
  poolUnits,
  availableBalance,
  filledSlots,
  totalSlots,
  isReady,
  isLocked,
  saving,
  onBack,
}) => {
  return (
    <div className="min-h-screen bg-slate-100 pb-20">
      <header className="bg-white shadow-sm px-4 py-2.5 flex items-center justify-between">
        <button 
          onClick={onBack} 
          className="p-1.5 text-slate-600 active:scale-90"
        >
          <ChevronLeft size={22} />
        </button>
        {/* Beta v2: Renamed from "Review & Lock" */}
        <h1 className="text-base font-bold text-slate-900">Review</h1>
        <div className="w-8" />
      </header>
      
      {/* Beta v2: Admin-controlled lock banner */}
      <WeekLockBanner isLocked={isLocked} />
      
      <main className="p-3 space-y-3">
        <div className="bg-white rounded-xl shadow-sm p-3">
         <UnitWheel roster={roster} totalCapacity={availableBalance} />
        </div>
        
        <div className="bg-white rounded-xl shadow-sm p-3 space-y-2">
          <div>
            <span className="text-[10px] font-semibold text-slate-400 uppercase">Position</span>
            <PositionStrip roster={roster} />
          </div>
          <div>
            <span className="text-[10px] font-semibold text-slate-400 uppercase">Above / Below</span>
            <OverUnderStrip roster={roster} />
          </div>
        </div>
        
        <div className="bg-white rounded-xl shadow-sm p-2 space-y-1">
          {roster.filter(s => s.player).map(s => (
            <div key={s.slot} className="flex items-center gap-2 p-2 rounded-lg bg-slate-50">
              <div 
                className="w-1 h-10 rounded-full" 
                style={{ backgroundColor: POSITION_COLORS[s.player.position] }} 
              />
              <div className="flex-1 min-w-0">
                <p className="text-sm font-bold text-slate-800 truncate">{s.player.name}</p>
                <p className="text-[10px] text-slate-500">
                  <span className="font-semibold">{s.side === 'OVER' ? 'Above' : 'Below'}</span> {s.prop?.stat} {s.prop?.line}
                </p>
              </div>
              <p className="text-lg font-black text-indigo-600 tabular-nums">{`$${s.units}`}</p>
            </div>
          ))}
        </div>
      </main>
      
      {/* Beta v2: Lock button removed entirely - users return via back button */}
    </div>
  );
};
